import { FrankliNotification } from '@app/models/notifications/frankli-notification.model';

export const mockNotifications: FrankliNotification[] = [

];